/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-07-12 14:46:32
 * @LastEditTime: 2022-07-13 15:29:05
 * @FilePath: /insurforce-backstage-platform-side/src/views/examine/typeManage/request.js
 */
import request from '@/utils/request';

// 审核流类型-列表
export function auditTypeList(data) {
  return request.post('admin/audit-type/list', data);
}
// 新增
export function auditTypeStore(data) {
  return request.post('/admin/audit-type/store', data);
}
// 详情
export function auditTypeDetail(data) {
  return request.post('/admin/audit-type/detail', data);
}
// 编辑
export function auditTypeEdit(data) {
  return request.post('/admin/audit-type/edit', data);
}
//资源
export function auditTypeResource(data) {
  return request.post('admin/audit-type/resource', data);
}

// 审核流进度-状态修改
export function auditScheduleStatus(data) {
  return request.post('admin/audit-schedule/status', data);
}
// 新增
export function auditScheduleStore(data) {
  return request.post('/admin/audit-schedule/store', data);
}
// 详情
export function auditScheduleResource(data) {
  return request.post('/admin/audit-schedule/resource', data);
}
// 编辑
export function auditScheduleEdit(data) {
  return request.post('/admin/audit-schedule/edit', data);
}